/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      "\u0130": "i",
      "I": "\u0131",
      "I\u0307": "i"
    }
  },
  az: {
    regexp: /[\u0130]/g,
    map: {
      "\u0130": "i",
      "I": "\u0131",
      "I\u0307": "i"
    }
  },
  lt: {
    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
    map: {
      "I": "i\u0307",
      "J": "j\u0307",
      "\u012E": "\u012F\u0307",
      "\xCC": "i\u0307\u0300",
      "\xCD": "i\u0307\u0301",
      "\u0128": "i\u0307\u0303"
    }
  }
};
/**
 * Lowercase a string.
 *
 * @param  {String} str
 * @return {String}
 */

module.exports = function (str, locale) {
  var lang = LANGUAGES[locale];
  str = str == null ? '' : String(str);

  if (lang) {
    str = str.replace(lang.regexp, function (m) {
      return lang.map[m];
    });
  }

  return str.toLowerCase();
};